"use strict";
exports.__esModule = true;
exports.DEFAULT_AUTH_GROUPS = exports.SYSTEM_ADMIN_GROUP = exports.AuthGroupName = void 0;
var permission_1 = require("./permission");
var AuthGroupName;
(function (AuthGroupName) {
    AuthGroupName["systemAdmin"] = "systemAdmin";
    AuthGroupName["surveyAdmin"] = "surveyAdmin";
    AuthGroupName["surveyEditor"] = "surveyEditor";
    AuthGroupName["dataEditor"] = "dataEditor";
    AuthGroupName["dataCleanser"] = "dataCleanser";
    AuthGroupName["dataAnalyst"] = "dataAnalyst";
})(AuthGroupName = exports.AuthGroupName || (exports.AuthGroupName = {}));
exports.SYSTEM_ADMIN_GROUP = { name: AuthGroupName.systemAdmin };
exports.DEFAULT_AUTH_GROUPS = [
    {
        name: AuthGroupName.surveyAdmin,
        permissions: [
            permission_1.Permission.permissionsEdit,
            permission_1.Permission.surveyEdit,
            permission_1.Permission.recordView,
            permission_1.Permission.recordCreate,
            permission_1.Permission.recordEdit,
            permission_1.Permission.recordCleanse,
            permission_1.Permission.recordAnalyse,
            permission_1.Permission.userEdit,
            permission_1.Permission.userInvite,
        ],
        recordSteps: {
            1: permission_1.RecordStepPermission.all,
            2: permission_1.RecordStepPermission.all,
            3: permission_1.RecordStepPermission.all
        }
    },
    {
        name: AuthGroupName.surveyEditor,
        permissions: [
            permission_1.Permission.surveyEdit,
            permission_1.Permission.recordView,
            permission_1.Permission.recordCreate,
            permission_1.Permission.recordEdit,
            permission_1.Permission.recordCleanse,
            permission_1.Permission.recordAnalyse,
        ],
        recordSteps: {
            1: permission_1.RecordStepPermission.all,
            2: permission_1.RecordStepPermission.all,
            3: permission_1.RecordStepPermission.all
        }
    },
    {
        name: AuthGroupName.dataAnalyst,
        permissions: [
            permission_1.Permission.recordView,
            permission_1.Permission.recordCreate,
            permission_1.Permission.recordEdit,
            permission_1.Permission.recordCleanse,
            permission_1.Permission.recordAnalyse,
        ],
        recordSteps: {
            1: permission_1.RecordStepPermission.all,
            2: permission_1.RecordStepPermission.all,
            3: permission_1.RecordStepPermission.all
        }
    },
    {
        name: AuthGroupName.dataCleanser,
        permissions: [permission_1.Permission.recordView, permission_1.Permission.recordCreate, permission_1.Permission.recordEdit, permission_1.Permission.recordCleanse],
        recordSteps: {
            1: permission_1.RecordStepPermission.all,
            2: permission_1.RecordStepPermission.all
        }
    },
    {
        name: AuthGroupName.dataEditor,
        permissions: [permission_1.Permission.recordView, permission_1.Permission.recordCreate, permission_1.Permission.recordEdit],
        recordSteps: {
            1: permission_1.RecordStepPermission.own
        }
    },
];
//# sourceMappingURL=authGroup.js.map